import { render } from "./RifModal.vue?vue&type=template&id=28bc981e&scoped=true"
import script from "./RifModal.vue?vue&type=script&lang=js"
export * from "./RifModal.vue?vue&type=script&lang=js"

import "./RifModal.vue?vue&type=style&index=0&id=28bc981e&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bc981e"]])

export default __exports__